<template>
  <div id="SeckillList">
    <div class="SeckillList_body">
      <!-- 顶部导航 -->
      <van-nav-bar title="" :border="false">
        <template #left>
          <van-icon name="arrow-left" size="18" color="#FFFFFF" />
        </template>
        <template #right>
          <van-icon name="service" size="18" color="#FFFFFF" />
        </template>
      </van-nav-bar>
      <van-image
        width="5.28rem"
        height="2.186rem"
        fit="contain"
        src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/seckill/top_msg.png"
        style="margin-bottom:-15px"
      />
      <!-- 倒计时 -->
      <van-count-down :time="time" format="DD/ HH:mm:ss">
        <template #default="timeData">
          <div class="timeDataStyle">
            <div class="colon">距结束还剩</div>
            <div class="block">{{ timeData.days }}</div>
            <div class="colon">天</div>
            <div class="block">{{ timeData.hours }}</div>
            <div class="colon">时</div>
            <div class="block">{{ timeData.minutes }}</div>
            <div class="colon">分</div>
            <div class="block">{{ timeData.seconds }}</div>
            <div class="colon">秒</div>
          </div>
        </template>
      </van-count-down>
    </div>
    <!-- tab切换 -->
    <div class="SeckillList_tab flex-c-c-c">
      <div :class="tabIndex === 1 ? 'tab_change tab_left':'tab_change tab_right'">
        <div :class="tabIndex === 1 ? 'left_msg tab_actived':'left_msg'" @click="tabChange(1)">正在秒杀</div>
        <div :class="tabIndex === 2 ? 'right_msg tab_actived':'right_msg'" @click="tabChange(2)">即将开始</div>
      </div>
      <div class="tab_list">
        <van-list :loading="loading" :finished="finished" finished-text="我也是有底线的..." @load="onLoad">
          <div v-for="(pro_item,pro_index) in list" :key="pro_index" class="pro_card">
            <div class="card_left">
              <van-image
                width="2.56rem"
                height="1.92rem"
                fit="contain"
                src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/uniapp/activity/activity_001.png"
              />
            </div>
            <div class="card_right">
              <div class="pro_name overflow-ellipsis">朗博特 咪多西盐酸多西环素片0.1南京朗博特 | 0.1g/片（80片）</div>
              <div class="pro_brand_model overflow-ellipsis">
                <span class="pro_brand">南京朗博特</span> |
                <span class="pro_model">0.1g/片（80片）</span>
              </div>
              <div class="pro_price_btn">
                <div class="pro_price">
                  <div class="pro_price_seckill">秒杀价 ￥<span
                    style="font-size:0.53rem"
                  >{{ $utils.moneyDote(25.19)[0] }}</span>.{{ $utils.moneyDote(25.19)[1] }}</div>
                  <div class="pro_price_shop">商城价￥39.00</div>
                </div>
                <div class="pro_btn">
                  <div>去抢购</div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>

  </div>
</template>

<script>
import './index.scss'
// 组件加载
export default {
  name: 'SeckillList',
  data() {
    return {
      // 倒计时
      time: 30 * 60 * 60 * 1000, // 30 代表分钟
      // tab
      tabIndex: 1,
      // 滚动列表
      loading: false,
      finished: false,
      list: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    }
  },
  methods: {
    // 切换tab
    tabChange(index) { this.tabIndex = index },
    onLoad() {
      setTimeout(() => {
        for (let i = 0; i < 10; i++) { this.list.push(this.list.length + 1) }
        // 加载状态结束
        this.loading = false
        // 数据全部加载完成
        if (this.list.length >= 40) { this.finished = true }
      }, 10)
    }
  }
}
</script>
